import { Injectable } from '@angular/core';
import {
    BANNER_NOTIFICATION_PRIORITY,
    IBannerNotification
} from '@app/core/model/banner-notification.model';

@Injectable({
    providedIn: 'root'
})
export class BannerNotificationsService {

    private priorityMap = new Map<string, number>();

    constructor() {
        BANNER_NOTIFICATION_PRIORITY.forEach((value: string, index: number) => {
            this.priorityMap.set(value, index + 1);
        });
    }

    sortNotification(notifications: IBannerNotification[]): IBannerNotification[] {
        return (notifications || []).sort((a: IBannerNotification, b: IBannerNotification) => (this.priorityMap.get(a.type) || 100) - (this.priorityMap.get(b.type) || 100));
    }
}
